import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createManager } from 'utils/redux-injectors';
import { SubscriptionDetailPageSaga } from './saga';
import { SubscriptionDetailPageState, UpdateSubscriptionAction } from './types';
import { Subscription } from 'types/models';
export const initialState: SubscriptionDetailPageState = {
  subscription: {},
  loading: false,
  error: false,
};

const slice = createSlice({
  name: 'SubscriptionDetailPage',
  initialState,
  reducers: {
    fetchSubscription(state, action: PayloadAction<string>) {
      state.loading = true;
      state.error = false;
      state.subscription = {};
    },
    fetchSubscriptionSucceed(state, action: PayloadAction<Subscription>) {
      state.loading = false;
      state.error = false;
      state.subscription = action.payload;
    },
    fetchSubscriptionFailed(state) {
      state.loading = false;
      state.error = true;
      state.subscription = {};
    },
    cleanup: () => initialState,
    updateSubscription(state, action: PayloadAction<UpdateSubscriptionAction>) {
      //TODO:When need loading on save, can hook logic here.
    },
    updateSubscriptionSucceeded(state, action: PayloadAction<Subscription>) {
      state.subscription = action.payload;
    },
  },
});

export const {
  actions: SubscriptionDetailPageActions,
  reducer: SubscriptionDetailPageReducer,
} = slice;

export const useSubscriptionDetailPageSlice = () => ({
  actions: slice.actions,
});

export const SubscriptionDetailPageManager = createManager({
  name: `${slice.name}Manager`,
  key: slice.name,
  reducer: slice.reducer,
  saga: SubscriptionDetailPageSaga,
});

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSubscriptionDetailPageSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
